export const baseURL = process.env.VUE_APP_API_URL
export const secretKey = process.env.VUE_APP_SECRET_KEY
export const needSocketAuth = process.env.NEED_SOCKET_AUTH
export const webSockets = {
  broker: process.env.VUE_APP_WEBSOCKET_BROKER,
  port: parseInt(process.env.VUE_APP_WEBSOCKET_PORT),
  sslStatus: process.env.VUE_APP_WEBSOCKET_SSL,
  userName: process.env.VUE_APP_WEBSOCKET_USERNAME,
  password: process.env.VUE_APP_WEBSOCKET_PASSWORD
}
